export default "__VITE_ASSET__B1Tic6X7__"